import { z } from 'zod';
import { restaurantCustomerCvxSchema } from '../schemas/restaurantCustomerSchema';
import { restaurantUserCvxSchema } from '../schemas/restaurantUserSchema';

const convexUserNoUserSchema = z.object({
  sub: z.null(),
  userType: z.null(),
});
export type ConvexUserNoUser = z.output<typeof convexUserNoUserSchema>;

export const convexUserSuperAdminSchema = z.object({
  /** Derived from the JWT token `subject` and not from Convex database. */
  sub: z.string(),
  /** Derived from the JWT token / Cognito user and not from Convex database. */
  userType: z.literal('superAdmin'), // <= Needs to be at top level for discriminated union
});
export type ConvexUserSuperAdmin = z.output<typeof convexUserSuperAdminSchema>;

export const convexUserRestaurantUserSchema = z.object({
  restaurantUser: restaurantUserCvxSchema,
  /** Derived from the JWT token `subject` and not from Convex database. */
  sub: z.string().readonly(),
  /** Derived from the JWT token / Cognito user and not from Convex database. */
  userType: z.literal('restaurantUser').readonly(),
});
export type ConvexUserRestaurantUser = z.output<typeof convexUserRestaurantUserSchema>;

export const convexUserRestaurantCustomerSchema = z.object({
  restaurantCustomer: restaurantCustomerCvxSchema,
  /** Derived from the JWT token `subject` and not from Convex database. */
  sub: z.string().readonly(),
  /** Derived from the JWT token / Cognito user and not from Convex database. */
  userType: z.literal('restaurantCustomer').readonly(),
});
export type ConvexUserRestaurantCustomer = z.output<typeof convexUserRestaurantCustomerSchema>;

export const convexUserSchema = z.discriminatedUnion('userType', [
  convexUserNoUserSchema,
  convexUserSuperAdminSchema,
  convexUserRestaurantUserSchema,
  convexUserRestaurantCustomerSchema,
]);
export type ConvexUser = z.output<typeof convexUserSchema>;
